import useScrollAnimation from "@/hooks/useScrollAnimation";
import { industriesData } from "@/mocks/homeData";

export default function IndustriesSection() {
  const { ref, isVisible } = useScrollAnimation(0.08);

  return (
    <section id="industries" className="w-full py-16 md:py-24 bg-background-50">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {industriesData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {industriesData.headline}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {industriesData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {industriesData.industries.map((industry) => (
            <div
              key={industry.name}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-accent-50 flex items-center justify-center shrink-0">
                  <i className={`${industry.icon} text-lg md:text-xl text-accent-500`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-1.5">
                    {industry.name}
                  </h4>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                    {industry.description}
                  </p>
                  <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full">
                    {industry.stats}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}